import { useEffect } from 'react';
import { useSiteConfig } from './useSiteConfig';

export const useFavicon = () => {
  const siteConfig = useSiteConfig();

  useEffect(() => {
    // Update favicon
    const updateFavicon = () => {
      // Remove existing favicon links and manifest
      const existingLinks = document.querySelectorAll("link[rel*='icon'], link[rel='manifest']");
      existingLinks.forEach(link => link.remove());

      if (siteConfig.faviconUrl) {
        // Add new favicon
        const favicon = document.createElement('link');
        favicon.rel = 'icon';
        favicon.type = 'image/x-icon';
        favicon.href = siteConfig.faviconUrl;
        document.head.appendChild(favicon);
        
        // Add 32x32 favicon
        const favicon32 = document.createElement('link');
        favicon32.rel = 'icon';
        favicon32.type = 'image/png';
        favicon32.setAttribute('sizes', '32x32');
        favicon32.href = siteConfig.faviconUrl.replace('favicon.ico', 'favicon-32x32.png');
        document.head.appendChild(favicon32);
        
        // Add 16x16 favicon
        const favicon16 = document.createElement('link');
        favicon16.rel = 'icon';
        favicon16.type = 'image/png';
        favicon16.setAttribute('sizes', '16x16');
        favicon16.href = siteConfig.faviconUrl.replace('favicon.ico', 'favicon-16x16.png');
        document.head.appendChild(favicon16);

        // Add apple touch icon if specified
        if (siteConfig.appleTouchIconUrl) {
          const appleTouchIcon = document.createElement('link');
          appleTouchIcon.rel = 'apple-touch-icon';
          appleTouchIcon.href = siteConfig.appleTouchIconUrl;
          document.head.appendChild(appleTouchIcon);
        }
        
        // Add web manifest if it exists
        const manifestPath = siteConfig.faviconUrl.replace('favicon.ico', 'site.webmanifest');
        const manifest = document.createElement('link');
        manifest.rel = 'manifest';
        manifest.href = manifestPath;
        document.head.appendChild(manifest);
      } else {
        // Fallback to default favicon
        const favicon = document.createElement('link');
        favicon.rel = 'icon';
        favicon.href = '/favicon.ico';
        document.head.appendChild(favicon);
      }
    };

    // Update page title
    const updateTitle = () => {
      if (siteConfig.name) {
        document.title = siteConfig.name;
      }
    };

    // Update meta description
    const updateMetaDescription = () => {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      if (siteConfig.description) {
        metaDescription.setAttribute('content', siteConfig.description);
      }
    };

    // Update theme color based on primary color
    const updateThemeColor = () => {
      let themeColor = document.querySelector('meta[name="theme-color"]');
      if (!themeColor) {
        themeColor = document.createElement('meta');
        themeColor.setAttribute('name', 'theme-color');
        document.head.appendChild(themeColor);
      }
      // Use the primary color from theme
      const primaryColor = siteConfig.theme?.primary?.[600] || '#3B82F6';
      themeColor.setAttribute('content', primaryColor);
    };

    updateFavicon();
    updateTitle();
    updateMetaDescription();
    updateThemeColor();
  }, [siteConfig]);
};

export default useFavicon;